import { useEffect, useState } from "react";
import { Layout, Menu, Avatar, Dropdown, Button, Tooltip, Spin } from "antd";
import { Link, useLocation, useHistory } from "react-router-dom";
import "../Partner.css";
import { logout } from '../../../configOidc';
import { LuLayoutDashboard, LuUsers, LuUserCog, LuFileText, LuShield, LuSettings, LuLogOut } from "react-icons/lu";
import { connect } from "react-redux";
import { hideLoader, showLoader } from "../../../_redux/loader/action";

const { Header, Sider, Content } = Layout;

const PartnerDashboardLayout = (props) => {
  const partnerData = JSON.parse(localStorage.getItem('userDetails'))
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const navigation = [
  { name: "Dashboard", href: "/PartnerLayoutPage", icon: <LuLayoutDashboard className="partnerMenuIcons" /> },
  partnerData.Designation === "Partner Admin" &&{ name: "Clients", href: "/PartnerClients", icon: <LuUsers   className="partnerMenuIcons" /> },
  partnerData.Designation === "Partner Admin" &&{ name: "Team Members", href: "/PartnerTeamMembers", icon: <LuUserCog className="partnerMenuIcons" /> },
  partnerData.Designation === "Partner Admin" &&{ name: "Requests", href: "/PartnerRequests", icon: <LuFileText  className="partnerMenuIcons" /> },
  // { name: "Admin Review", href: "/PartnerAdminReview", icon: <LuShield  className="partnerMenuIcons" /> },
].filter(Boolean);

  useEffect(()=>{
    if (window.location.pathname === "/PartnerLayoutPage") {
      let userkeys = ["userDetails", "UserName", "CAUserName", "UserType"]
      Object.keys(localStorage).forEach(x => {
        if (!userkeys.includes(x)) {
          localStorage.removeItem(x);
        }
      });
    }
  },[])

  const handleLogout = () => {
    // history.push("/");
    logout();
  };

  const accountMenu = (
    <Menu className="partnerUserDropdown" style={{border: "1px solid #e1e7ef", borderRadius: "6px", padding:'4px'}}>
      {/* <Menu.ItemGroup className="partnerUserDropdownTitle" style={{color: "#000", fontWeight:600}} title="My Account"></Menu.ItemGroup> */}
      <Menu.ItemGroup className="partnerUserDropdownTitle" style={{color: "#000", fontWeight:600}} title={`${localStorage.getItem("CAUserName")} (${partnerData.Designation})`}></Menu.ItemGroup>
      <Menu.Divider style={{backgroundColor:"e1e7ef"}} />
      <Menu.Item key="settings" icon={<LuSettings style={{fontSize:"16px"}}  />}>
        Settings
      </Menu.Item>
      <Menu.Divider style={{backgroundColor:"e1e7ef"}} />
      <Menu.Item key="logout" icon={<LuLogOut style={{fontSize:"16px"}}  />} onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Layout className="min-vh-100">
        {props.loader_reducer.loader ? <div className="spinLoader">
          <Spin size="large" />
        </div> : ""}
      {/* Fixed Sidebar */}
      <Sider
        // collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        width={60}
        collapsedWidth="0"
        className="partner-fixed-sider"
        style={{zIndex: collapsed ? 9999: 0, position: collapsed ? "fixed" : "static"}}
      >
        <div className="partnerSidebar d-flex flex-column">
          {/* Logo Section */}
          <div style={{paddingBottom: 10, height:'64px'}} className="sidebarHeader d-flex justify-content-start px-4 pt-3">
            {/* <img src="/images/uBooks_360.jpg" alt="uBooks" style={{ height: "40px" }} />
            <Button
              type="text"
              icon={<CloseOutlined />}
              className="d-lg-none"
              onClick={() => {setMobileOpen(false);setCollapsed(true)}}
            /> */}
          </div>

          {/* Menu Section */}
          <Menu
            mode="inline"
            theme="light"
            selectedKeys={[location.pathname]}
            className="partnerSideBarMenu flex-grow-1"
            style={{
              border: "none",
              padding: "16px 12px",
              boxShadow: "unset",
            }}
          >
            {navigation.map((item) => (
                <Menu.Item
                  key={item.href}
                  icon={item.icon}
                  onClick={() => setMobileOpen(false)}
                >
                  {/* <Link to={item.href}>{item.name}</Link> */}
                  <Tooltip  placement="right" color={"#2463eb"} title={item.name}>
                    <Link to={item.href}></Link>
                  </Tooltip >
                </Menu.Item>
            ))}
          </Menu>
        </div>
      </Sider>

      {/* Main Content Layout */}
      <Layout style={{height: "100vh" }} className="partnerLayout">
        <Header
          className="bg-white text-start p-0 d-flex justify-content-between align-items-center"
          style={{
            position: "sticky",
            top: 0,
            borderBottom: "1px solid #e1e7ef",
          }}
        >
        {/* <div className="d-flex justify-content-between align-items-center"> */}
          <img src="/images/uBooks_360.jpg" alt="uBooks" style={{ height: "40px" }} />
          {/* {collapsed && <Button
            type="text"
            icon={<MenuOutlined />}
            className="d-lg-none"
            onClick={() => {setMobileOpen(!mobileOpen);setCollapsed(false)}}
          />} */}
          <div className="sidebarUser">
            <Dropdown overlay={accountMenu} >
              <Button type="text" className="d-flex align-items-center text-start">
                <Avatar
                  size="large"
                  // style={{ backgroundColor: "#2463eb", marginRight: "8px" }}
                >
                  {localStorage.getItem("CAUserName")
                    .split(" ")
                    .map((n) => n[0])
                    .join("").toLocaleUpperCase()
                  }
                </Avatar>
                {/* <div className="text-left"> */}
                  {/* <div className="sidebarUserName" style={{ fontWeight: 600 }}>{localStorage.getItem("CAUserName")}</div>
                  <div style={{ fontSize: "12px",fontWeight: 400, color: "#999" }}>{localStorage.getItem("UserType")}</div> */}
                {/* </div> */}
              </Button>
            </Dropdown>
          </div>
        {/* </div> */}
        </Header>
        <Content
          style={{
            overflowY: "auto", // ✅ only this scrolls
            height: "100vh",
            backgroundColor: "#f8f9fa",
          }}
        >
          <div className="m-2">{props.children}</div>
        </Content>
      </Layout>
    </Layout>
  );
};

const mapStateToProps = ({ loader_reducer }) => {
    return { loader_reducer }
}

const mapDispatchToProps = { showLoaderAsync: showLoader, hideLoaderAsync: hideLoader };

export default connect(mapStateToProps, mapDispatchToProps)(PartnerDashboardLayout);
